


export default function handleGraphqlMutationResult(result: {
  data?: any;
  errors?: any;
}) {
  if (result.errors) {
    throw result.errors;
  }
  return result.data;
}